import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default () => {
  const authReducer = useSelector((state) => state.authReducer);
  const { sessionId, isLogin } = authReducer;
  return useMemo(() => {
    if (sessionId && isLogin) {
      return sessionId;
    }
    return '';
  }, [sessionId, isLogin]);
};
